/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M12 3C16.9706 3 21 7.02944 21 12M12 3C10.5632 3 9.20496 3.33671 8 3.93552M12 3L12 1M21 12C21 13.4368 20.6633 14.795 20.0645 16M21 12H23"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12 21C7.02944 21 3 16.9706 3 12M12 21C14.4853 21 16.7353 19.9926 18.364 18.364M12 21V23M3 12C3 9.51472 4.00736 7.26472 5.63604 5.63604M3 12H1M18.364 18.364L22 22M18.364 18.364L14.129 14.1136L9.87868 9.87868M2 2L5.63604 5.63604M5.63604 5.63604L9.87868 9.87868M9.87868 9.87868C9.69388 10.0635 9.53308 10.2723 9.40135 10.5C9.14609 10.9413 9 11.4536 9 12C9 13.6569 10.3431 15 12 15C12.7684 15 13.4692 14.7111 14 14.2361"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M18.364 18.3637C16.7353 19.9923 14.4853 20.9997 12 20.9997C7.02944 20.9997 3 16.9703 3 11.9997C3 9.51442 4.00736 7.26442 5.63604 5.63574L9.87868 9.87838C9.33577 10.4213 9 11.1713 9 11.9998C9 13.6566 10.3431 14.9998 12 14.9998C12.8324 14.9998 13.5856 14.6608 14.1291 14.1133L18.364 18.3637Z"
				fill="currentColor"
			/>
			<path
				d="M12 21C7.02944 21 3 16.9706 3 12M12 21C14.4853 21 16.7353 19.9926 18.364 18.364M12 21V23M3 12C3 9.51472 4.00736 7.26472 5.63604 5.63604M3 12H1M12 3C16.9706 3 21 7.02944 21 12M12 3C10.5632 3 9.20496 3.33671 8 3.93552M12 3V1M21 12C21 13.4368 20.6633 14.795 20.0645 16M21 12H23M18.364 18.364L22 22M18.364 18.364L14.129 14.1136L9.87868 9.87868M2 2L5.63604 5.63604M5.63604 5.63604L9.87868 9.87868M9.87868 9.87868C9.69388 10.0635 9.53308 10.2723 9.40135 10.5C9.14609 10.9413 9 11.4536 9 12C9 13.6569 10.3431 15 12 15C12.7684 15 13.4692 14.7111 14 14.2361"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.75 1C12.75 0.585786 12.4142 0.25 12 0.25C11.5858 0.25 11.25 0.585786 11.25 1V2.27845C9.97147 2.37581 8.76065 2.72 7.66623 3.26388C7.29529 3.44822 7.14403 3.89836 7.32836 4.26929C7.5127 4.64023 7.96284 4.79149 8.33377 4.60716C9.43734 4.05873 10.6815 3.75 12 3.75C16.5564 3.75 20.25 7.44365 20.25 12C20.25 13.3185 19.9413 14.5627 19.3928 15.6662C19.2085 16.0372 19.3598 16.4873 19.7307 16.6716C20.1016 16.856 20.5518 16.7047 20.7361 16.3338C21.28 15.2394 21.6242 14.0285 21.7215 12.75H23C23.4142 12.75 23.75 12.4142 23.75 12C23.75 11.5858 23.4142 11.25 23 11.25H21.7216C21.3574 6.4632 17.5368 2.64256 12.75 2.27842V1ZM2.53033 1.46967C2.23744 1.17678 1.76256 1.17678 1.46967 1.46967C1.17678 1.76256 1.17678 2.23744 1.46967 2.53033L4.5957 5.65636C3.2863 7.18345 2.44047 9.12152 2.27844 11.25H1C0.585786 11.25 0.25 11.5858 0.25 12C0.25 12.4142 0.585786 12.75 1 12.75H2.27842C2.64256 17.5368 6.4632 21.3574 11.25 21.7216V23C11.25 23.4142 11.5858 23.75 12 23.75C12.4142 23.75 12.75 23.4142 12.75 23V21.7216C14.8785 21.5595 16.8165 20.7137 18.3436 19.4043L21.4697 22.5303C21.7626 22.8232 22.2374 22.8232 22.5303 22.5303C22.8232 22.2374 22.8232 21.7626 22.5303 21.4697L18.8953 17.8346L18.8943 17.8336L14.6603 13.5842L14.6584 13.5823L10.409 9.34835L10.408 9.34738L6.16637 5.10571L2.53033 1.46967ZM3.75 12C3.75 9.99158 4.46691 8.15171 5.66002 6.72068L8.87136 9.93202C8.82976 9.99485 8.78999 10.059 8.75214 10.1245C8.43263 10.6768 8.25 11.3182 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75C12.7673 15.75 13.4818 15.5189 14.0762 15.1231L17.2804 18.3391C15.8492 19.5327 14.0089 20.25 12 20.25C7.44365 20.25 3.75 16.5564 3.75 12Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M12 21C7.02944 21 3 16.9706 3 12M12 21C14.4853 21 16.7353 19.9926 18.364 18.364M12 21V23M3 12C3 9.51472 4.00736 7.26472 5.63604 5.63604M3 12H1M18.364 18.364L22 22M18.364 18.364L14.129 14.1136L9.87868 9.87868M2 2L5.63604 5.63604M5.63604 5.63604L9.87868 9.87868M9.87868 9.87868C9.69388 10.0635 9.53308 10.2723 9.40135 10.5C9.14609 10.9413 9 11.4536 9 12C9 13.6569 10.3431 15 12 15C12.7684 15 13.4692 14.7111 14 14.2361M8 3.93552C9.20496 3.33671 10.5632 3 12 3M12 3C15.5337 3 18.5918 5.03656 20.0645 8M12 3V1M20.0645 16C20.6633 14.795 21 13.4368 21 12H23"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M12 21C7.02944 21 3 16.9706 3 12M12 21C14.4853 21 16.7353 19.9926 18.364 18.364M12 21V23M3 12C3 9.51472 4.00736 7.26472 5.63604 5.63604M3 12H1M12 3C16.9706 3 21 7.02944 21 12M12 3C10.5632 3 9.20496 3.33671 8 3.93552M12 3V1M21 12C21 13.4368 20.6633 14.795 20.0645 16M21 12H23M18.364 18.364L22 22M18.364 18.364L14.129 14.1136L9.87868 9.87868M2 2L5.63604 5.63604M5.63604 5.63604L9.87868 9.87868M9.87868 9.87868C9.69388 10.0635 9.53308 10.2723 9.40135 10.5C9.14609 10.9413 9 11.4536 9 12C9 13.6569 10.3431 15 12 15C12.7684 15 13.4692 14.7111 14 14.2361"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.16637 5.1059C6.45926 5.39879 6.45926 5.87367 6.16637 6.16656C4.67259 7.66034 3.75 9.72181 3.75 12.0002C3.75 16.5565 7.44365 20.2502 12 20.2502C14.2784 20.2502 16.3399 19.3276 17.8336 17.8338C18.1265 17.5409 18.6014 17.5409 18.8943 17.8338C19.1872 18.1267 19.1872 18.6016 18.8943 18.8945C17.296 20.4928 15.1434 21.5396 12.75 21.7218V23.0002C12.75 23.4144 12.4142 23.7502 12 23.7502C11.5858 23.7502 11.25 23.4144 11.25 23.0002V21.7218C6.4632 21.3576 2.64256 17.537 2.27842 12.7502H1C0.585786 12.7502 0.25 12.4144 0.25 12.0002C0.25 11.586 0.585786 11.2502 1 11.2502H2.27844C2.46063 8.8568 3.50743 6.70418 5.10571 5.1059C5.3986 4.81301 5.87348 4.81301 6.16637 5.1059Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.75 1C12.75 0.585786 12.4142 0.25 12 0.25C11.5858 0.25 11.25 0.585786 11.25 1V2.27845C9.97147 2.37581 8.76065 2.72 7.66623 3.26388C7.29529 3.44822 7.14403 3.89836 7.32836 4.26929C7.5127 4.64023 7.96284 4.79149 8.33377 4.60716C9.43734 4.05873 10.6815 3.75 12 3.75C16.5563 3.75 20.25 7.44365 20.25 12C20.25 13.3185 19.9413 14.5627 19.3928 15.6662C19.2085 16.0372 19.3598 16.4873 19.7307 16.6716C20.1016 16.856 20.5518 16.7047 20.7361 16.3338C21.28 15.2394 21.6242 14.0285 21.7215 12.75H23C23.4142 12.75 23.75 12.4142 23.75 12C23.75 11.5858 23.4142 11.25 23 11.25H21.7216C21.3574 6.4632 17.5368 2.64256 12.75 2.27842V1ZM2.53033 1.46967C2.23744 1.17678 1.76256 1.17678 1.46967 1.46967C1.17678 1.76256 1.17678 2.23744 1.46967 2.53033L8.87138 9.93204C8.479 10.5247 8.25 11.236 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75C12.764 15.75 13.4753 15.521 14.068 15.1286L21.4697 22.5303C21.7626 22.8232 22.2374 22.8232 22.5303 22.5303C22.8232 22.2374 22.8232 21.7626 22.5303 21.4697L14.6517 13.591L10.409 9.34835L2.53033 1.46967Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
